import { ContactModel } from '../contact.model';
import { OrderTypeDto } from '../orders/order-type.dto';

/**
 * Data transfer object for backstage users to have enough information to create a new draft/order
 */
export class DraftInitInfoDto {
  /**
   * different order types with currently available seasons information attached to it
   */
  public orderTypes: OrderTypeDto[];
  /**
   * user contacts information for sales representatives
   */
  public userContacts: ContactModel[];
}
